// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__AUe37","inner":"Footer_inner__9_WEO","nextIcon":"Footer_nextIcon__HRFA3","innerLeft":"Footer_innerLeft__1A5P2"};